export const API_BASE_URL = (() => {
  switch (process.env.REACT_APP_ENVIRONMENT) {
    case 'local':
      return process.env.REACT_APP_LOCAL_ENDPOINT;
    case 'staging':
      return process.env.REACT_APP_STAGING_ENDPOINT;
    case 'production':
      return process.env.REACT_APP_PRODUCTION_ENDPOINT;
    default:
      throw new Error('REACT_APP_ENVIRONMENT is not set to a valid value (local, staging, or production). Please check your .env file.');
  }
})();

export const ROUTES = {
  DASHBOARD: '/dashboard',
  LOGIN: '/login',

  USERS: '/users',
  USERS_CREATE: '/users/create',
  USERS_EDIT: '/users/:id/edit',
  USERS_TRASH: '/users/trash',

  ROLES: '/roles',
  ROLES_CREATE: '/roles/create',
  ROLES_EDIT: '/roles/:id/edit',

  SERVICES: '/services',
  SERVICES_CREATE: '/services/create',
  SERVICES_EDIT: '/services/:id/edit',
  SERVICES_TRASH: '/services/trash',

  SKILLS: '/skills',
  SKILLS_CREATE: '/skills/create',
  SKILLS_EDIT: '/skills/:id/edit',
  SKILLS_TRASH: '/skills/trash',

  FAQS: '/faqs',
  FAQS_CREATE: '/faqs/create',
  FAQS_EDIT: '/faqs/:id/edit',
  FAQS_TRASH: '/faqs/trash',

  TESTIMONIALS: '/testimonials',
  TESTIMONIALS_CREATE: '/testimonials/create',
  TESTIMONIALS_EDIT: '/testimonials/:id/edit',
  TESTIMONIALS_TRASH: '/testimonials/trash',

  HEADER_FOOTER: '/header-footer',
  HEADER_FOOTER_CREATE: '/header-footer/create',
  HEADER_FOOTER_EDIT: '/header-footer/:id/edit',
  HEADER_FOOTER_TRASH: '/header-footer/trash',

  CLIENTS: '/clients',
  CLIENTS_CREATE: '/clients/create',
  CLIENTS_EDIT: '/clients/:id/edit',
  CLIENTS_TRASH: '/clients/trash',

  WORK_EDUCATION: '/work-education',
  WORK_EDUCATION_CREATE: '/work-education/create',
  WORK_EDUCATION_EDIT: '/work-education/:id/edit',
  WORK_EDUCATION_TRASH: '/work-education/trash',

  PROJECTS: '/projects',
  PROJECTS_CREATE: '/projects/create',
  PROJECTS_EDIT: '/projects/:id/edit',
  PROJECTS_TRASH: '/projects/trash',

  SEO_SETTINGS: '/seo-settings',
  SEO_SETTINGS_EDIT: '/seo-settings/:id/edit',
  NOTIFICATION_SETTINGS: '/notification-settings',
  TERMS_CONDITIONS: '/terms-conditions',
  TERMS_CONDITIONS_EDIT: '/terms-conditions/:id/edit',
  PRIVACY_POLICY: '/privacy-policy',
  PRIVACY_POLICY_EDIT: '/privacy-policy/:id/edit',
  SETTINGS: '/settings',
  SETTINGS_EDIT: '/settings/:id/edit',
  CONTACT_LEADS: '/contact-leads',
  LEAD_STATUS: '/lead-status',
  LEAD_STATUS_CREATE: '/lead-status/create',
  LEAD_STATUS_EDIT: '/lead-status/:id/edit',
  LEAD_STATUS_TRASH: '/lead-status/trash',
  BLOG_CATEGORIES: '/blog-categories',
  BLOG_CATEGORIES_CREATE: '/blog-categories/create',
  BLOG_CATEGORIES_EDIT: '/blog-categories/:id/edit',
  BLOG_CATEGORIES_TRASH: '/blog-categories/trash',
  BLOGS: '/blogs',
  BLOGS_CREATE: '/blogs/create',
  BLOGS_EDIT: '/blogs/:id/edit',
  BLOGS_TRASH: '/blogs/trash',
  NEWSLETTER_SUBSCRIBERS: '/newsletter-subscribers',
  NEWSLETTER_SUBSCRIBERS_CREATE: '/newsletter-subscribers/create',
  NEWSLETTER_ANALYTICS: '/newsletter-subscribers/analytics',
  JOBS: '/jobs',
};

export const API_ENDPOINTS = {
  AUTH: '/auth',
  USERS: '/users',
  ROLES: '/roles',
  PERMISSIONS: '/permissions',
  SERVICES: '/services',
  SKILLS: '/skills',
  FAQS: '/faqs',
  TESTIMONIALS: '/testimonials',
  HEADER_FOOTERS: '/header-footers',
  CLIENTS: '/clients',
  WORK_EDUCATION: '/work-education',
  PROJECTS: '/projects',
  BLOG_CATEGORIES: '/blog-categories',
  BLOGS: '/blogs',
  PRIVACY_POLICY: '/privacy-policies',
  TERMS_CONDITIONS: '/terms-conditions',
  NOTIFICATION_SETTINGS: '/notification-settings',
  LEAD_STATUSES: '/lead-statuses',
  LEADS: '/leads',
  SEO_SETTINGS: '/seo-settings',
  SETTINGS: '/settings',
  SETTINGS_CLEAR_CACHE: '/settings/clear-cache',
  GENERATE_SITEMAP: '/settings/generate-sitemap',

  ANALYTICS_SUMMARY_STATS: '/analytics/summary-stats',
  ANALYTICS_VISITORS_BY_DATE: '/analytics/visitors-by-date',
  ANALYTICS_VISITORS_BY_COUNTRY: '/analytics/visitors-by-country',
  ANALYTICS_TRAFFIC_SOURCES: '/analytics/traffic-sources',
  ANALYTICS_MOST_VISITED_PAGES: '/analytics/most-visited-pages',
  ANALYTICS_TOP_OPERATING_SYSTEMS: '/analytics/top-operating-systems',
  ANALYTICS_TOP_BROWSERS: '/analytics/top-browsers',
  NEWSLETTER_SUBSCRIBERS: 'newsletter-subscribers',
  NEWSLETTER_ANALYTICS: 'newsletter-subscribers/analytics',
  NEWSLETTER_SUBSCRIBERS_STORE: 'newsletter-subscribers',
  NEWSLETTER_SUBSCRIBERS_UPDATE: (id) => `newsletter-subscribers/${id}`,
  BLOG_SEND_NOTIFICATION: (id) => `/blogs/${id}/send-notification`,
  BLOG_PROCESS_QUEUED_NOTIFICATIONS: '/blogs/process-queued-notifications',
  BLOG_ANALYTICS: (id) => `/blogs/${id}/analytics`,
  JOBS: '/jobs',
};

export const HEADER_FOOTER_POSITIONS = [
  { value: 'header', label: 'Header' },
  { value: 'footer', label: 'Footer' },
];

export const SETTING_KEYS = {
  SITE_NAME: 'site_name',
  EMAIL: 'email',
  TEAMS_URL: 'teams_url',
  UPWORK_URL: 'upwork_url',
  LINKEDIN_URL: 'linkedin_url',
  GITHUB_URL: 'github_url',
  ANALYTICS_PROPERTY_ID: 'analytics_property_id',
  ANALYTICS_PROPERTY_CREDENTIALS: 'analytics_property_credentials',
  MAIL_HOST: 'mail_host',
  MAIL_PORT: 'mail_port',
  MAIL_USERNAME: 'mail_username',
  MAIL_PASSWORD: 'mail_password',
  MAIL_ENCRYPTION: 'mail_encryption',
  MAIL_FROM_ADDRESS: 'mail_from_address',
  MAIL_FROM_NAME: 'mail_from_name',
  FAVICON: 'favicon',
};

export const PERMISSIONS = {
  MANAGE_USERS: 'manage_users',
  MANAGE_ROLES: 'manage_roles',
  MANAGE_PERMISSIONS: 'manage_permissions',

  MANAGE_LEADS: 'manage_leads',
  MANAGE_LEAD_STATUSES: 'manage_lead_statuses',
  MANAGE_NOTIFICATION_SETTINGS: 'manage_notification_settings',

  MANAGE_SERVICES: 'manage_services',
  MANAGE_BLOGS: 'manage_blogs',
  MANAGE_CATEGORIES: 'manage_categories',
  MANAGE_SKILLS: 'manage_skills',
  MANAGE_FAQS: 'manage_faqs',
  MANAGE_TESTIMONIALS: 'manage_testimonials',
  MANAGE_PROJECTS: 'manage_projects',
  MANAGE_HEADER_FOOTER: 'manage_header_footer',
  MANAGE_SEO_SETTINGS: 'manage_seo_settings',
  MANAGE_TERMS_CONDITIONS: 'manage_terms_conditions',
  MANAGE_PRIVACY_POLICY: 'manage_privacy_policy',
  MANAGE_WORK_EDUCATION: 'manage_work_education',
  MANAGE_CLIENTS: 'manage_clients',
  MANAGE_SETTINGS: 'manage_settings',
  MANAGE_NEWSLETTER_SUBSCRIBERS: 'manage_newsletter_subscribers',
  MANAGE_JOBS: 'manage_jobs',
};